import React, { useEffect, useState } from "react";
import { WeatherCondition } from "../services/weatherService";

interface WeatherIconProps {
  condition: WeatherCondition;
  className?: string;
  loading?: "eager" | "lazy";
}

const METEOCONS_BASE_URL = "https://cdn.meteocons.com/3.0.0-next.10/svg-static/fill";

const isNight = (iconCode: string) => iconCode.toLowerCase().endsWith("n");

const getMeteoconName = (condition: WeatherCondition) => {
  const group = condition.group.toLowerCase();
  const night = isNight(condition.icon_code);
  const dayOrNight = night ? "night" : "day";

  if (group.includes("thunder")) return "thunderstorms-rain";
  if (group.includes("snow")) return "snow";
  if (group.includes("rain") || group.includes("drizzle")) return "partly-cloudy-day-rain";
  if (/(mist|smoke|haze|dust|fog|sand|ash|squall|tornado)/.test(group)) return `fog-${dayOrNight}`;
  if (group.includes("clear")) return `clear-${dayOrNight}`;

  if (group.includes("cloud")) {
    const iconCode = condition.icon_code.slice(0, 2);
    return iconCode === "02" || iconCode === "03" ? `partly-cloudy-${dayOrNight}` : `overcast-${dayOrNight}`;
  }

  return `partly-cloudy-${dayOrNight}`;
};

export const getMeteoconIconUrl = (condition: WeatherCondition) =>
  `${METEOCONS_BASE_URL}/${getMeteoconName(condition)}.svg`;

const WeatherIcon: React.FC<WeatherIconProps> = ({ condition, className = "", loading }) => {
  const meteoconUrl = getMeteoconIconUrl(condition);
  const [source, setSource] = useState(meteoconUrl);

  useEffect(() => {
    setSource(meteoconUrl);
  }, [meteoconUrl]);

  return (
    <img
      src={source}
      alt={condition.description}
      className={className}
      loading={loading}
      onError={() => setSource((currentSource) => currentSource === condition.icon_url ? currentSource : condition.icon_url)}
    />
  );
};

export default WeatherIcon;
